/**
 * @file store 文件
 */

import {store} from '@/lib/Store';
import allActions from '../actions';

// ATTENTION: processInitData 函数名在node里用，各业务线保持一致
const processInitData = (data = {}) => {
    const {
        bsCommon,
        bsBrowser,
        bsData = {},
    } = data;
    const {
        header: topbar,
        superlanding = [],
        isBaiJiaHao,
        deadlink,
        singularityBack,
        comment: {
            tid,
            forbidden,
        } = {
            // forbidden: false,
            // tid: '1113000027190162'
        },
        nid,
        displaytime,
        changanData,
        guideAction,
    } = bsData;
    // 兼容IE8
    const isArray = arr =>
        Object.prototype.toString.call(arr) === '[object Array]';
    // superlanding 后端会偶现返回对象的情况，这种情况跳过
    const article = isArray(superlanding)
        ? superlanding.find(item => item.itemType === 'article')
        : undefined;
    let relate = isArray(superlanding)
        ? superlanding.filter(item => {
            if (item.itemType === 'relatedNews') {
                return {
                    ...item,
                    singularityBack,
                };
            }
            if (item.itemType === 'recentArticle') {
                return item;
            }
        }) : undefined;
    return {
        common: {
            ...bsCommon,
            browser: bsBrowser || {},
            isLogin: (topbar && topbar.islogin) || false,
            isBjh: isBaiJiaHao || 1,
            isDeadlink: deadlink || false,
            nid,
            follow: false, // 是否已关注
            sid: bsData.sid,
        },
        showToast: false,
        toastInfo: {
            content: '',
            type: 'default',
        },
        displaytime,
        topbar: {
            ...topbar,
            hideLoginInfo: true,
        },
        header: article,
        article: article,
        relate: relate,
        comment: {
            isCommentShow: !forbidden && !!tid,
            tid,
        },
        changanData,
        tts: {
            isShowTts: false,
            isPlaying: false,
            highlightIndex: 0,
            isPlayEnd: false,
        },
        guideAction: guideAction || {},
        pcRelate: {
            recentArticle: [],
            relateNews: [],
            topList: [],
        },
    };
};

const initStore = (data = {}) => {
    const storeData = processInitData(data);
    store.initData(storeData).addActions(allActions);
    // 全局挂载store实例，有用到，勿删！！！
    window.__s = store;
    return store;
};

export default initStore;
export {processInitData};
